import data from "../../.sourceflow/assets.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getAsset = ({ path, size }, locale = "en") => {
  const items = new BaseCollection(data, locale).getItems();
  const asset = items.find((i) => i.path === path);

  if (size) {
    return asset
      ? asset.file.replace("https://cdn.sourceflow.co.uk/", `https://cdn.sourceflow.co.uk/variant/${size}/`)
      : null;
  }

  return asset ? asset.file : null;
};
